<div style="display: flex; justify-content: center; align-items: center;" class="h-full">

  <input
    id="{{ formLabelPhoto }}"
    type="file"
    [accept]="accept"
    (change)="onFileSelected($event)"
    [disabled]="disabled"
    hidden
    >

    <div>
      <label class="label-pz">{{label}}</label>

      <div
        [ngStyle]="{'width': width, 'min-height': height}"
        [ngClass]="(form.get(formLabelPhoto)?.invalid && form?.get(formLabelPhoto)?.touched) ? 'invalid-document': 'valid-document'"
        class="image-preview flex justify-content-center align-items-center image-container input-file-container"
        (click)="triggerFileInputClick()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        [class.dragging]="isDragging"
        style="cursor: pointer; border-radius: 12px; text-align: center;"

        >
        @if (form.get(formLabelPhoto)?.value && type === 'image') {
          <img
            [ngStyle]="{'width': width, 'min-height': height}"
            style="cursor: pointer;"
            [src]="$safeNavigationMigration(form.get(formLabelPhoto)?.value)"
            alt="Imagen seleccionada"
            class="image"
            >
        }
        @if (form.get(formLabelPhoto)?.value && type === 'document') {
          <div class="w-full h-full flex justify-content-center align-items-center flex-wrap document-selected">
            <div class="flex align-items-center justify-content-center w-full font-bold p-5">
              <i [ngStyle]="{'font-size': '56px', 'color': accept === '.pdf' ? 'red' : '#1D6A3F'}"
              [ngClass]="accept === '.pdf' ? 'pi pi-file-pdf' : 'pi pi-file-excel'"></i>
            </div>
            <div style="color: var(--primary-color-mnt)" class="flex align-items-center justify-content-center w-full font-bold">
              {{ fileName }}
            </div>
            <div class="flex align-items-center justify-content-center w-full">
              {{ fileSize }} KB
            </div>
          </div>
        }

        @if (!form.get(formLabelPhoto)?.value) {
          <div
            class="w-full flex flex-column justify-content-center align-items-center"
            style="cursor: pointer; border-radius: 12px; text-align: center; padding: 10px;"
            >
            @if (!disabled) {
              <div>
                <div><i style="font-size: 25px;" class='bx bx-upload'></i></div>
                <div style="padding-bottom: 5px;"><span style="font-size: 12px;">Arrastrar y soltar el archivo para cargar <b style="font-size: 12px;">o</b></span></div>
                <p-button severity="info">
                  <span style="display: flex;" class="p-button-label">
                    <span style="font-size: 12px;">&nbsp;Cargar</span>
                  </span>
                </p-button>
                <div style="font-size: 12px; padding-top: 5px;">Máximo <span style="font-weight: bold;">250KB</span></div>
              </div>
            }
          </div>
        }

        @if (!disabled) {
          <div class="overlay">
            <div class="overlay-content">
              @if (form.get(formLabelPhoto)?.value) {
                <div pTooltip="quitar" (click)="clearDocument($event)" style="position: absolute; right: 10px; top: 10px; border-color: #0354A9 !important;" class="flex justify-content-end flex-wrap">
                  <i style="font-size: 12px; padding: 3px; background: red; border-radius: 10px;" class='bx bx-x'></i>
                </div>
              }
              <div><i style="font-size: 25px;" class='bx bx-upload'></i></div>
              <div style="padding-bottom: 5px;"><span style="font-size: 12px;">Arrastrar y soltar el archivo para cargar <b style="font-size: 12px;">o</b></span></div>
              <p-button severity="info">
                <span style="display: flex;" class="p-button-label">
                  <span style="font-size: 12px;">&nbsp;Cargar</span>
                </span>
              </p-button>
              <div style="font-size: 12px; padding-top: 5px">Máximo <span style="font-weight: bold;">250KB</span></div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>